import * as React from 'react';
import Footer from '../../components/Footer';
import TranslationService, { ITranslationService } from '../../services/TranslationService';

class NotFound extends React.Component {
    private readonly translationService: ITranslationService;

    constructor(props: any) {
        super(props);
        this.translationService = TranslationService.getInstance();
    }

    public render() {
        return (
            <div className='not-found'>
                <div className='content'>
                    {this.translationService.translate('notFound')}
                </div>

                <Footer />
            </div>
        );
    }
}

export default NotFound;



// WEBPACK FOOTER //
// ./src/screens/NotFound/index.tsx